import catalogModule from '../catalogModule';
// Consider to introduce globally after getting some user feedback
function imageLoad($timeout) {
    "ngInject";
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.bind('load', function () {
                if (scope.item && scope.item.thumbnail) {
                    $timeout(function () {
                        scope.item.thumbnail.isLoaded = true;
                    });
                }
            });
        }
    }
}

catalogModule.directive("imageLoad", imageLoad);

export default imageLoad;